import { render, staticRenderFns } from "./LabElementView.vue?vue&type=template&id=3579d0d8"
import script from "./LabElementView.vue?vue&type=script&lang=js"
export * from "./LabElementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3579d0d8')) {
      api.createRecord('3579d0d8', component.options)
    } else {
      api.reload('3579d0d8', component.options)
    }
    module.hot.accept("./LabElementView.vue?vue&type=template&id=3579d0d8", function () {
      api.rerender('3579d0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labElement/LabElementView.vue"
export default component.exports